import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const TabsClassName = `${CLASS_NAME_PREFIX}-tabs`;
export const TabsListClassName = `${TabsClassName}__list`;
export const TabsPanelClassName = `${TabsClassName}__panel`;
export const TabsListTabClassName = `${TabsListClassName}-tab`;
export const TabsListTabCountClassName = `${TabsListTabClassName}-count`;
